import { DirectiveOptions } from 'vue';
const clickOutside: DirectiveOptions = {
    bind: (el: any, binding) => {
        el.event = (event: any): void => {
            try {
                // Use composedPath() to traverse into shadow DOM without triggering
                // the ShadyDOM polyfill's getRootNode retargeting (which throws when
                // nodes are not part of the polyfilled tree).
                const path: EventTarget[] = event.composedPath ? event.composedPath() : [event.target];
                const isOutside = !path.some((node: any) => el === node || el.contains(node));
                if (isOutside) {
                    binding.value(event);
                }
            } catch (_e) {
                // Guard against ShadyDOM polyfill errors on web-component events
            }
        };
        document.body.addEventListener('click', el.event);
    },
    unbind: (el: any) => {
        document.body.removeEventListener('click', el.event);
    },
};

export default clickOutside;
